import {PaymentMethod} from '../models';

export const getPaymentMethods = (data: any): PaymentMethod[] =>
  data.map(getPaymentMethod);

export const getPaymentMethod = (data: any): PaymentMethod => {
  return {
    id: data.id,
    customerId: data.customer_id,
    merchantId: data.merchant_id,
    userId: data.user_id,
    nickname: data.nickname,
    hasCvv: Boolean(data.has_cvv),
    isDefault: Boolean(data.is_default),
    method: data.method,
    personName: data.person_name,
    cardType: data.card_type,
    cardLastFour: data.card_last_four,
    cardExp: data.card_exp,
    addressZip: data.address_zip,
    addressCountry: data.address_country,
    isTokenized: data.is_tokenized,
  };
};
